import { Provider } from "@/styles";
import type { AppProps } from "next/app";
import { Roboto_Condensed } from "next/font/google";
import defaultSeo from "../next-seo.config";
import { DefaultSeo } from "next-seo";
import { Analytics } from "@vercel/analytics/next";
import { SpeedInsights } from "@vercel/speed-insights/next";
import Script from "next/script";

const inter = Roboto_Condensed({ subsets: ["latin"] });

export default function App({ Component, pageProps }: AppProps) {
  return (
    <Provider>
      <style jsx global>{`
        html {
          font-family: ${inter.style.fontFamily};
        }
      `}</style>
      <DefaultSeo {...defaultSeo} />
      {/* Google tag (gtag.js) */}
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=AW-17698699970"
        strategy="lazyOnload"
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('set', 'ads_data_redaction', true);
          gtag('config', 'AW-17698699970', {
            allow_ad_personalization_signals: false,
            allow_google_signals: false,
          });
        `}
      </Script>
      <Component {...pageProps} />
      <Analytics />
      <SpeedInsights />
    </Provider>
  );
}
